import React from 'react'
import clsx from 'clsx'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faChevronRight,
  faChevronLeft,
} from '@fortawesome/free-solid-svg-icons'
import Slick from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import * as styles from '../styles/components/SuccessCases.module.scss'

import { Button } from './Button'
import { SectionTitle } from './SectionTitle'

const cases = [
  {
    title: `CTG Brasil`,
    text: `Implementação das normas 9001 / 14001 / 45001 / 55001`,
    quantity: 500,
  },
  {
    title: `UNIMED Botucatu`,
    text: `Adequação para atendimento a resolução normativa RN 443 / 2019`,
    quantity: 100,
  },
  {
    title: `Biosev`,
    text: `Documentação dos processos de Originação e transformação de atividades manuais`,
    quantity: 60,
  },
]

export const SuccessCases: React.FC = () => {
  return (
    <section id="cases-sucesso" className={clsx([`my-5`, styles.cases])}>
      <div className="container">
        <SectionTitle
          title="Cases de Sucesso"
          description="Veja alguns de nossos cases de sucesso. Entre em contato e saiba mais sobre nossas melhorias que transformaram as organizações."
        />
        <div className={styles.mainCases}>
          <Slick
            className={styles.slick}
            adaptiveHeight={true}
            infinite={false}
            autoplay={false}
            slidesToShow={3}
            slidesToScroll={1}
            dots={false}
            draggable={false}
            speed={300}
            dotsClass={clsx([`slick-dots`, styles.customDots])}
            nextArrow={<FontAwesomeIcon icon={faChevronRight} />}
            prevArrow={<FontAwesomeIcon icon={faChevronLeft} />}
            responsive={[
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
                  dots: true,
                  arrows: false,
                },
              },
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  dots: true,
                  arrows: false,
                },
              },
            ]}
          >
            {cases.map((item, key) => (
              <div className={styles.caseBox} key={key}>
                <div className={styles.caseItem}>
                  <div className={styles.title}>
                    <h2>{item.title}</h2>
                    <p>{item.text}</p>
                  </div>
                  <div className={styles.counter}>
                    {item.quantity}
                    <span>Melhorias</span>
                  </div>
                </div>
              </div>
            ))}
          </Slick>
        </div>
        <div className="container">
          <div className="row mt-5 pt-5 pt-lg-0 align-items-center justify-content-center">
            <a
              href="https://valoremelhoria.com.br/#b8673"
              target="_blank"
              rel="noopener"
            >
              <Button>Conheça todos os nossos clientes</Button>
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}
